"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
export default function Qualifications() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const standards = [{
    title: "Licensed & insured",
    description: "Operates with active business licensing and liability insurance for trade work on your residential or commercial property."
  }, {
    title: "Direct contractor oversight",
    description: "Prince is on-site managing each phase, inspecting work before handover, and keeping communication clear with the property owner."
  }, {
    title: "Written estimates & clear scopes",
    description: "Every job begins with an on-site walkthrough and an itemized breakdown of materials, labor, and anticipated project schedule."
  }, {
    title: "Dumfries & surrounding area coverage",
    description: "Based in Dumfries, Virginia, providing timely visits, consistent scheduling, and dependable follow-through across Prince William County."
  }];
  return <section id="qualifications-certifications" ref={sectionRef} className={`bg-background text-foreground py-14 md:py-20 lg:py-24 border-b border-border transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 md:mb-14">
          <h2 className="font-serif font-normal text-3xl md:text-4xl lg:text-5xl leading-[1.12] text-foreground tracking-tight border-l-4 border-primary pl-4 mb-4">
            How we work
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed pl-5">
            Practical standards you can rely on when hiring Ablaze Contracting Service LLC.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {standards.map((item, i) => <div key={i} className="bg-card border border-border rounded p-6 md:p-7 flex flex-col justify-start">
              <div className="flex items-center gap-3 mb-3">
                <Check className="size-5 text-primary shrink-0" />
                <h3 className="font-serif font-normal text-xl text-foreground">
                  {item.title}
                </h3>
              </div>
              <p className="text-base leading-relaxed text-muted-foreground">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}